/* unplugin-vue-components disabled */import script from "./PermissionMenu.vue?vue&type=script&setup=true&lang=js"
export * from "./PermissionMenu.vue?vue&type=script&setup=true&lang=js"

import "./PermissionMenu.vue?vue&type=style&index=0&id=a7102598&lang=scss&scoped=true"

import exportComponent from "D:\\igencloud_team\\ident-doc-admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a7102598"]])

export default __exports__